<template>
  <div class="dt-details2">
    <div class="dt-details--header">
      <div class="title" :title="group && group.group_id">
        <span>{{ group.group_name }}</span>
      </div>
    </div>
    <!-- <div class="dt-details--body">
      <div class="dt-details--col">
        <div class="ut-flex">
          <div class="ut-text-secondary">Last Modified</div>
          <div style="margin-left: 8px">
            {{ (group && group.last_modified) || "" }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      default: { group_name: "Group Name" }
    },
  },
  mounted: function () {
    // console.log("RRRRRR",this.group)
  },
  methods: {},
};
</script>

<style>
</style>
